import client from './apiUtilsConnector';

async function getCountries() {
  try {
    const typeResponse = await client().get('/countries');
    return typeResponse.data.data;
  } catch (e) {
    return [];
  }
}

export default {
  getCountries,
};
